import React, { useState } from 'react';
import { Dialog, DialogContent } from '@mui/material';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';

const AuthDialog = ({ open, onClose }) => {
  const [isLogin, setIsLogin] = useState(true);

  const handleToggleForm = () => {
    setIsLogin(!isLogin);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent>
        {isLogin ? (
          <LoginForm onToggleForm={handleToggleForm} onClose={onClose} />
        ) : (
          <RegisterForm onToggleForm={handleToggleForm} onClose={onClose} />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AuthDialog;
